import * as R from 'ramda';
import moment from 'moment';

export default function ClearNotificationsController(
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  alerts,
  loaderService,
  orgDataService,
  confirmDialog
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleClearNotifications = _handleClearNotifications;
  vm.handleSelectAll = _handleSelectAll;
  vm.handleSelectNotificationChange = _handleSelectNotificationChange;
  vm.selectedList = [];
  vm.totalCount = 0;
  
  activate();

  /** ************************************************
   * Event Handlers
   */

  function activate() {
    vm.totalCount = vm.alertList.length;
  }

  function _handleClearNotifications($event) {
    ssDialogService.dialogs.global.confirmClearNotificationsDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Clear Notifications?',
        message: `Are you sure you want to clear the selected notifications? They cannot be recovered once removed.`,
        handleYesClick: () => {
          _handleConfirmClearNotifications();
        },
        handleNoClick: () => {
          _handleCancelClearNotifications();
        },
      })
    );

    ssDialogService.show(ssDialogService.dialogs.global.confirmClearNotificationsDialog);
    
  }

  function _handleConfirmClearNotifications($event) {
    if ($scope.clearNotificationsDialogForm.$valid) {
      const selectedIds = [];
      R.forEach((item) => {
        selectedIds.push(item.applicationNotificationId);
      }, vm.selectedList);

      loaderService.showViewLoader = true;
      orgDataService.dismissApplicationAllNotifications(selectedIds)
        .then((response) => {
          alerts.success('The notifications were cleared successfully.');
          loaderService.showViewLoader = false;
          _handleCancelClearNotifications();
          _handleCloseDialog();
          $rootScope.$broadcast('refreshNotifications');
      }).catch(() => {
        alerts.error('An error occurred while clearing notifications.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
    }
  }

  function _handleCancelClearNotifications($event) {
    ssDialogService.hide(ssDialogService.dialogs.global.confirmClearNotificationsDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.global.dismissRemindersDialog);
  }

  function _handleSelectAll() {
    vm.selectedList = [];

    vm.alertList.forEach((alert) => {       
      alert.isSelected = vm.selectAll;
      if(alert.isSelected){
        vm.selectedList.push(alert);
      }   
    })
        
    vm.changeIsSelected = vm.selectAll;
  }

  function _handleSelectNotificationChange(key, selectedAlert) {
    vm.selectedList = [];

    vm.alertList.forEach((alert) => {
      if(alert.isSelected){
        vm.selectedList.push(alert);
      }                        
    })

    vm.changeIsSelected = vm.selectedList.length > 0;
    vm.selectAll = vm.selectedList.length === vm.totalCount;
  }

}

ClearNotificationsController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'alerts',
  'loaderService',
  'orgDataService',
  'confirmDialog',
];
